/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import classnames from 'classnames';
import { colord } from "colord";

// below here for testing imports
import { PanelBody,RangeControl,SelectControl } from '@wordpress/components';

const { assign, merge } = lodash;
const { __ } = wp.i18n;




const GeneralPanel = (myprops) => {

// Need to understand what I am passing here
	const props = myprops.props
	const {attributes,setAttributes} = props;
	const {aplomask,aploclip,aploshadow,aplotexture,aplohoverduration,aplohoverease,aplozindex} = props.attributes;

	const patterngroupSelect = () => {
		if (typeof aplopatterngroup === 'undefined') {
			return
		}
		<p>Select a color group for either the group or column blocks</p>
		return <SelectControl
		label={__('Pattern Group', 'aploblocks')}
		labelposition='left'
		value={aplopatterngroup}
		options={[
				 {label:__('<none>','aploblocks'),value: ''},
				 {label:__('Theme','aploblocks'),value: 'zero'},
				 {label:__('Switch FG & BG', 'aploblocks'),value: 'one'},
				 {label:__('Primary BG', 'aploblocks'),value: 'two'},
				 {label:__('Tertiary BG', 'aploblocks'),value: 'three'},
			]}
		onChange={(value) => {
			setAttributes({ aplopatterngroup: value });
		}}
		 
				  
	/>
	}

	// change to move pattern group out as it is theme specific
	//{typeof patterngroupSelect !== 'undefined' ?	patterngroupSelect() : ''}
	

	return (

		<PanelBody title={__('Aplo General Styles', 'aplostyles')} initialOpen={false} className="aplogeneralstyles">

						{typeof hdgDecorSelect !== 'undefined' ?	hdgDecorSelect() : ''}
						
	
						{typeof borderSelect !== 'undefined' ?	borderSelect() : ''}
						
					
						<p>{__('Add a preconfigured box-shadow','aploblocks')}</p>
						<SelectControl
                            label={__('Shadow', 'aploblocks')}
							labelPosition='left'
                            value={aploshadow}
                            options={[
                                     {label:__('<none>','aploblocks'),value: ''},
                                     {label:__('Small', 'aploblocks'),value: 'small'},
									 {label:__('Medium', 'aploblocks'),value: 'med'},
                                     {label:__('Large', 'aploblocks'),value: 'large'},
                            ]}
                            onChange={(value) => {
								setAttributes({ aploshadow: value });
							}}            
                        />

						<p>{__('Set a texture background to the block','aploblocks')}</p>
                        <SelectControl
                            label={__('Background', 'aploblocks')}
							labelPosition='left'
                            value={aplotexture}
                            options={[
                                     {label:__('<none>','aploblocks'),value: ''},
                                     {label:__('Texture 1', 'aploblocks'),value: 'one'},
                                     {label:__('Texture 2', 'aploblocks'),value: 'two'},
									{label:__('Texture 3', 'aploblocks'),value: 'three'},
									{label:__('Texture 4', 'aploblocks'),value: 'four'},
									{label:__('Texture 5', 'aploblocks'),value: 'five'},
									{label:__('Texture 6', 'aploblocks'),value: 'six'},
									{label:__('Texture 7', 'aploblocks'),value: 'seven'},
									{label:__('Texture 8', 'aploblocks'),value: 'eight'},
									{label:__('Texture 9', 'aploblocks'),value: 'nine'},
									{label:__('Texture 10', 'aploblocks'),value: 'ten'},
                            ]}
							
                            onChange={(value) => {
								setAttributes({ aplotexture: value });
							}}
                             
							         
                        />
				
					<h2>{__('Hover Transition Settings')}</h2>
					<p>Set the hover transitions if you do not want the default settings</p>
					<RangeControl
						label={__('Duration','aploblocks')}
						labelPosition='left'
						value={ aplohoverduration }
						onChange={(value) => {
							setAttributes({aplohoverduration: value});
						}}
						min={ 0 }
						max={ 5000 }
						step={50}
						allowReset={true}
					/>

					<SelectControl
						label={__('Easing', 'aploblocks')}
						labelPosition='left'			
						value={aplohoverease}
						options={[
							{label: __('<default>', 'aploblocks'),value: ''},
							{label: __('ease (Slow-Fast-Slow)', 'aploblocks'),value: 'ease'},
							{label: __('ease-in (Slow-Fast)', 'aploblocks'),value: 'ease-in'},
							{label: __('ease-out (Fast-Slow)', 'aploblocks'),value: 'ease-out'},
							{label: __('ease-in-out (Slow-Fast-Slow)', 'aploblocks'),value: 'ease-in-out'},
						]}
						onChange={(value) => {setAttributes({ aplohoverease: value })}}
					/>			

					<p>{__('Set the z-index value to make the block appear above or below other blocks','aploblocks')}</p>
					<RangeControl
						label={__('Z-index','aploblocks')}
						value={ aplozindex }
						onChange={(value) => {
							setAttributes({aplozindex: value});
						}}
						min={ -5 }
						max={ 15 }
						step={1}
						allowReset={true}
					/>
				</PanelBody>


	)




}



export default GeneralPanel